import React from "react";
import { Button } from "@mui/material";
import IconLeftArrow from "src/assets/images/icon_left_arrow.svg";
import IconRemove from "src/assets/images/icon_remove.svg";

export const UnlistClientForm = ({setIsUnlistClient, handleUnlistClient, individualClientInfo }) => {

  /** handler functions--------------------------------------------------- **/
  const handleUnlistClientModalClose = () => {
    setIsUnlistClient(false);
  };

  const handleokHandle = () => {
    handleUnlistClient(individualClientInfo?.id);
  };

  return (
    <>
      <div>
        <div className="depot-form-header-style">
          <span className="allocate-mgnr-header-color me-2">UNLIST</span>
          <span className="allocate-mgnr-subheader-color">
            {individualClientInfo.name}
          </span>
        </div>
        <div style={{ paddingLeft: 100, paddingRight: 100 }}>
          <div className="d-flex flex-column" style={{ marginTop: 100 }}>
            <span className="depotManagerName-style common-text-for-removeDepotManager">
              {individualClientInfo.name}
            </span>
            <span className="removeDepotManager-text-removed common-text-for-removeDepotManager mb-4">
              will be unlisted{" "}
            </span>
            <span className="long-text-style-unlist-depot mb-2">
              This action cannot be undone.
            </span>
            <span className="long-text-style-unlist-depot mb-2">
              This does not delete any data.
            </span>
            <span className="long-text-style-unlist-depot mb-2">
              This project will still show up in old records / search results
              where relevant and can be viewed.
            </span>
            <span className="long-text-style-unlist-client">
              Cannot be unlisted as long as there are items in the depot
              allocated to this client.
            </span>
          </div>

          <div className="d-flex flex-column" style={{ marginTop: 100 }}>
            <span className="mb-3 confirm-msg-for-removeDepotManager">
              Are you sure you want to proceed?
            </span>
            <div className="d-flex flex-row">
              <Button
                variant="outlined"
                className="btn-bootstrap-submit-style"
                startIcon={
                  <img
                    src={IconLeftArrow}
                    width={15}
                    height={15}
                    alt="new"
                  ></img>
                }
                onClick={handleUnlistClientModalClose}
                type="submit"
              >
                No, Go Back
              </Button>

              <Button
                onClick={() => handleokHandle()}
                variant="outlined"
                className="btn-bootstrap-submit-style ms-3"
                style={{ color: "red", borderColor: "red" }}
                startIcon={
                  <img src={IconRemove} width={15} height={15} alt="new"></img>
                }
              >
                Yes, Unlist Client
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
